/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * TreeIcon
 */
export default class TreeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12.87 2.504l4 7A1 1 0 0116 11h-.133l3.011 5.521A1 1 0 0118.001 18h-5v3a1 1 0 01-.883.993l-.117.007a1 1 0 01-1-1v-3h-5a1 1 0 01-.877-1.479L8.134 11h-.133a1 1 0 01-.868-1.496l4-7a1 1 0 011.737 0zM12 5.016L9.725 9h.094a1 1 0 01.878 1.479L7.686 16h8.63l-3.01-5.521A1 1 0 0114.183 9h.095l-2.277-3.984z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

